"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeHelpPosition = void 0;
var RangeHelpPosition;
(function (RangeHelpPosition) {
    RangeHelpPosition["BOTTOM"] = "bottom";
    RangeHelpPosition["INSIDE"] = "inside";
})(RangeHelpPosition || (exports.RangeHelpPosition = RangeHelpPosition = {}));
